<template>
    <v-navigation-drawer class="q-summit-sidebar-drawer" :class="{ 'q-summit-sidebar-drawer__opened': doShowDrawer}" light right :width="doShowDrawer ? '100%' : 0" temporary v-model="doShowDrawer">
        <QSummitSidebar />
    </v-navigation-drawer>
</template>
<script>
import { store } from './store/sidebar-store'
import QSummitSidebar from "./QSummitSidebar.vue"

export default {
    components: { QSummitSidebar },

    computed: {
        doShowDrawer: {
            get() { return store.doShowSummitSidebar },
            set(val) { store.doShowSummitSidebar = val }
        }
    }
}
</script>
<style lang="scss">
.q-summit-sidebar-drawer {
    width: 100%;
    max-width: 350px !important;
    z-index: 7;
    position: fixed;

    &__opened {
        overflow: visible !important;

        .v-navigation-drawer {
            &__content {
                overflow: visible !important;
            }
        }
    }
}
</style>